import React from 'react';
import PropTypes from 'prop-types';

import EventCard from 'components/cards/entities/EventCard';
import InstituteCard from 'components/cards/entities/InstituteCard';
import LiveCard from 'components/cards/entities/LiveCard';
import MovieCard from 'components/cards/entities/MovieCard';
import PersonCard from 'components/cards/entities/PersonCard';
import PoemCard from 'components/cards/entities/PoemCard';
import PromoBlockCard from 'components/cards/entities/PromoBlockCard';
import PublicationCard from 'components/cards/entities/PublicationCard';
import SpecialProjectCard from 'components/cards/entities/SpecialProjectCard';

import { EntityPropType } from 'propTypes/common';

const entityTypeHash = {
	persons: PersonCard,
	promoBlocks: PromoBlockCard,
	institutes: InstituteCard,
	publications: PublicationCard,
	poems: PoemCard,
	movies: MovieCard,
	events: EventCard,
	broadcast: LiveCard,
	specialProjects: SpecialProjectCard
};

const EntityCard = ({ entity, entityType, ...props }) => {
	const Card = entityTypeHash[entityType];

	return Card ? <Card entity={entity} {...props} /> : null;
};

EntityCard.propTypes = {
	entity: EntityPropType.isRequired,
	entityType: PropTypes.oneOf(Object.keys(entityTypeHash)).isRequired
};

export default EntityCard;
